import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import auth from './AuthService';
import packageJson from '../../package.json';
import BotStatusBadge from './BotStatus/BotStatusBadge';
import './Navbar.css';

function Navbar({ onRefresh, botStatus }) {
  const isAdmin = auth.isAdmin ? auth.isAdmin() : false;
  const [isOpen, setIsOpen] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const navbarRef = useRef(null);
  //const navigate = useNavigate();

  const toggleNavbar = () => {
    setIsOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const logout = () => {
    auth.logout();
    window.location.replace('/');
    closeMenu();
  };

  const refreshEvents = async () => {
    if (refreshing) return;
    setRefreshing(true);
    try {
      const res = await auth.fetch('/events/refresh', { method: 'POST' });
      console.log('Refresh result:', res.message || res);
      if (res.error) {
        alert('Refresh failed: ' + res.error);
      }
    } catch (err) {
      console.error('Refresh failed:', err);
      alert('Refresh failed: ' + (err.message || 'Unknown error'));
    } finally {
      if (onRefresh) {
        await onRefresh();
      }
      setRefreshing(false);
      closeMenu();
    }
  };

  useEffect(() => {
    const updateContentPadding = () => {
      const navbar = navbarRef.current;
      const content = document.querySelector('.container-fluid');
      if (navbar && content) {
        const collapsedHeight = isOpen ? 0 : navbar.offsetHeight + 15; // Height + 5px top + 10px bottomiteral: true;
        const paddingHeight = isOpen ? navbar.offsetHeight + 15 : collapsedHeight; // Add 15px (5px top + 10px bottom)
        console.log('Is open:', isOpen, 'Navbar height:', navbar.offsetHeight, 'Padding:', paddingHeight);
        content.style.paddingTop = `${paddingHeight}px`;
      }
    };

    updateContentPadding();
    window.addEventListener('resize', updateContentPadding);
    return () => window.removeEventListener('resize', updateContentPadding);
  }, [isOpen]);

  return (
    <nav className="navbar my-navbar navbar-expand-lg" ref={navbarRef}>
      <Link to="/" className="navbar-brand ps-3">
        The Golf Booking Minion v.{packageJson.version}
      </Link>
      <button
        className="navbar-toggler"
        type="button"
        onClick={toggleNavbar}
        aria-controls="navbarNav"
        aria-expanded={isOpen}
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className={`navbar-collapse ${isOpen ? 'show' : 'collapse'}`} id="navbarNav">
        <ul className="navbar-nav">
          <li className="navbar-item">
            <Link to="/" className="nav-link ps-3" onClick={closeMenu}>
              Events
            </Link>
          </li>
          <li className="navbar-item">
            <Link to="/edit-profile" className="nav-link ps-3" onClick={closeMenu}>
              Edit Profile
            </Link>
          </li>
          {isAdmin && (
            <li className="navbar-item">
              <Link to="/bot-status" className="nav-link ps-3" onClick={closeMenu}>
                Bot Status
              </Link>
            </li>
          )}
          <li className="navbar-item">
            <Link to="/setup-bot" className="nav-link ps-3" onClick={closeMenu}>
              Setup Bot
            </Link>
          </li>
          {isAdmin && (
            <li className="navbar-item">
              <Link to="/administration" className="nav-link ps-3" onClick={closeMenu}>
                Administration
              </Link>
            </li>
          )}
        </ul>
        <div className="d-flex ms-auto">
          {isAdmin && (
            <BotStatusBadge
              onlineCount={botStatus ? botStatus.filter(b => b.status === 'online').length : 0}
              totalCount={botStatus ? botStatus.length : 0}
              onClick={() => {
                const el = document.querySelector('[href="/bot-status"]');
                if (el) el.click();
              }}
            />
          )}
          {isAdmin && (
            <button type="button" className="btn btn-info mx-1" onClick={refreshEvents} disabled={refreshing}>
              {refreshing ? 'Refreshing Events...' : 'Refresh Events'}
            </button>
          )}
          <button type="button" className="btn logout-button mx-1" onClick={logout}>
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
